export enum Colours {
  blue = '#007bff',
  indigo = '#6610f2',
  purple = '#6f42c1',
  pink = '#e83e8c',
  red = '#dc3545',
  orange = '#fd7e14',
  yellow = '#ffc107',
  green = '#28a745',
  cyan = '#17a2b8',
  teal = '#20c997',
  white = '#fff',
  gray100 = '#f8f9fa',
  gray200 = '#e9ecef',
  gray300 = '#dee2e6',
  gray400 = '#ced4da',
  gray500 = '#adb5bd',
  gray600 = '#6c757d',
  gray700 = '#495057',
  gray800 = '#343a40',
  gray900 = '#212529',
  black = '#000',

  blue200 = '#0090ff',
  indigo200 = '#b39ddb',
  purple200 = '#ce93d8',
  pink200 = '#f48fb1',
  red200 = '#e57373',
  orange200 = '#ffab91',
  yellow200 = '#ffff00',
  green200 = '#69f0ae',
  teal200 = '#80cbc4',
  cyan200 = '#80deea',
}
